import * as LoadingStatus from '@coconut/constants/loadingState';

import fileDefaultObject from '@snapask/common-components/constants/uploadFileSchemaForZendesk';

export const types = {
  SUBMIT_REPORT_REQUEST: 'SUBMIT_REPORT_REQUEST',
  SUBMIT_REPORT_SUCCESS: 'SUBMIT_REPORT_SUCCESS',
  SUBMIT_REPORT_FAILURE: 'SUBMIT_REPORT_FAILURE',

  UPLOAD_FILE_REQUEST: 'UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',

  REMOVE_FILE_REQUEST: 'REMOVE_FILE_REQUEST',

  TOGGLE_REPORT_FORM: 'TOGGLE_REPORT_FORM',
  HIDE_REPORT_FORM: 'HIDE_REPORT_FORM',
  SHOW_REPORT_FORM: 'SHOW_REPORT_FORM',
  SAVE_CURRENT_DATA: 'SAVE_CURRENT_DATA',
};

export const actions = {
  submitReport: (email, reportMessage) => ({
    type: types.SUBMIT_REPORT_REQUEST,
    payload: {
      email,
      reportMessage,
    },
  }),
  submitReportSuccess: () => ({
    type: types.SUBMIT_REPORT_SUCCESS,
  }),
  submitReportFailed: () => ({ type: types.SUBMIT_REPORT_FAILURE }),
  uploadFile: (file) => ({
    type: types.UPLOAD_FILE_REQUEST,
    payload: {
      file,
    },
  }),
  uploadFileSuccess: (file) => ({
    type: types.UPLOAD_FILE_SUCCESS,
    payload: {
      file,
    },
  }),
  uploadFileFailed: () => ({ type: types.UPLOAD_FILE_FAILURE }),
  removeFile: (token) => ({
    type: types.REMOVE_FILE_REQUEST,
    payload: {
      token,
    },
  }),
  toggleReportForm: () => ({ type: types.TOGGLE_REPORT_FORM }),
  hideReportForm: () => ({ type: types.HIDE_REPORT_FORM }),
  showReportForm: () => ({ type: types.SHOW_REPORT_FORM }),
  saveCurrentData: ({ email, message }) => ({
    type: types.SAVE_CURRENT_DATA,
    payload: {
      email,
      message,
    },
  }),
};

const initialState = {
  loadingState: LoadingStatus.EMPTY,
  files: [],
  isReportFormOpen: false,
  isReportFormEnable: false,
  email: '',
  message: '',
};

/*eslint-disable complexity */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUBMIT_REPORT_REQUEST:
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
      };
    case types.SUBMIT_REPORT_SUCCESS:
      return {
        ...initialState,
      };
    case types.SUBMIT_REPORT_FAILURE:
      return {
        ...state,
        loadingState: LoadingStatus.ERROR,
      };
    case types.UPLOAD_FILE_REQUEST: {
      const file = Object.assign(fileDefaultObject(), {
        name: action.payload.file.name,
        isUploading: true,
      });
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
        files: state.files.concat([file]),
      };
    }
    case types.UPLOAD_FILE_SUCCESS: {
      state.files.pop();
      const file = Object.assign(fileDefaultObject(), action.payload.file);
      return {
        ...state,
        loadingState: LoadingStatus.READY,
        files: state.files.concat([file]),
      };
    }
    case types.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        loadingState: LoadingStatus.ERROR,
      };
    case types.REMOVE_FILE_REQUEST:
      return {
        ...state,
        loadingState: LoadingStatus.LOADING,
        files: state.files.filter(
          (file) => file.token !== action.payload.token
        ),
      };
    case types.TOGGLE_REPORT_FORM:
      return {
        ...state,
        isReportFormOpen: !state.isReportFormOpen,
      };
    case types.HIDE_REPORT_FORM:
      return {
        ...state,
        isReportFormEnable: false,
      };
    case types.SHOW_REPORT_FORM:
      return {
        ...state,
        isReportFormEnable: true,
      };
    case types.SAVE_CURRENT_DATA:
      return {
        ...state,
        email: action.payload.email,
        message: action.payload.message,
      };
    default:
      return state;
  }
};

export default reducer;

export const getFiles = (state) => state.report.files;
export const getIsReportFormOpen = (state) => state.report.isReportFormOpen;
export const getIsReportFormEnable = (state) => state.report.isReportFormEnable;
export const getEmail = (state) => state.report.email;
export const getMessage = (state) => state.report.message;



// WEBPACK FOOTER //
// ./src/services/redux/report.js